import Icon from 'components/Icon';
import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';
import { AuthContext } from 'constants/contexts';

function OrdersButton() {
  const { pathname } = useLocation();
  const { isLoggedIn } = useContext(AuthContext);

  // todo better path match
  const isActive = pathname.startsWith('/profile/orders');

  return (
    <Stack
      alignItems="center"
      component={Link}
      to={isLoggedIn ? '/profile/orders' : '/login'}
      className="footer-btn"
      spacing="6px"
    >
      {
        isActive ? <Icon name="order-filled" size={24} sx={{ color: 'primary.main' }} /> : <Icon name="order-outlined" size={24} sx={{ color: 'text.secondary' }} />
      }
      <Typography variant="body-caption" color={isActive ? 'primary' : 'text.secondary'}>
        Orders
      </Typography>
    </Stack>
  );
}

export default OrdersButton;
